import _ from 'lodash';
import React from 'react';

import {CREDIT_NOTE_STATUSES, XERO_STATUSES} from 'ducks/reporting';

import './styles.css';

// TODO: Drop the usage of label here
interface CreditNoteStatusTagProps {
  status: string;
  label: string;
}

const STATUS_TO_COLOR_MAPPER = {
  [CREDIT_NOTE_STATUSES.PARTIALLY_PAID]: {
    displayLabel: 'Partialy paid',
    backgroundColor: '#FFE6C2',
    textColor: '#E96200',
    borderColor: '#FFE6C2'
  },
  [CREDIT_NOTE_STATUSES.PAID]: {
    displayLabel: 'Paid',
    backgroundColor: '#D4F1CA',
    textColor: '#228100',
    borderColor: '#D4F1CA'
  },
  [CREDIT_NOTE_STATUSES.VOID]: {
    displayLabel: 'Void',
    backgroundColor: '#E1E8F0',
    textColor: '#6E7B8C',
    borderColor: '#d2d9e2'
  },
  [CREDIT_NOTE_STATUSES.UPCOMING]: {
    displayLabel: 'Upcoming',
    backgroundColor: '#49EEE9',
    textColor: '#006A67',
    borderColor: '#49EEE9'
  },
  [XERO_STATUSES.NOT_SYNCED]: {
    displayLabel: 'Not synced',
    backgroundColor: '#FF4444',
    textColor: '#FFFFFF',
    borderColor: '#FF4444'
  }
};

class CreditNoteStatusTag extends React.Component<CreditNoteStatusTagProps> {
  static NOT_SYNCED = XERO_STATUSES.NOT_SYNCED;
  static VOID = CREDIT_NOTE_STATUSES.VOID;

  render() {
    const {status} = this.props;

    const {backgroundColor, textColor, borderColor, displayLabel}: any = _.get(
      STATUS_TO_COLOR_MAPPER,
      status,
      {}
    );

    return (
      <div
        className="CreditNoteStatusTag colab-centered colab-bold"
        style={{
          backgroundColor,
          borderColor,
          color: textColor
        }}>
        {displayLabel}
      </div>
    );
  }
}

export default CreditNoteStatusTag;
